import React from "react";
import { AgGridReact } from "@ag-grid-community/react";
import useVoterTableFunctions from "./Voters/useVoterTableFunctions";

const ManageVotersTableView = () => {
  const { columnDefs, rowData, handleRowClick } = useVoterTableFunctions();
  console.log(rowData)
  return (
    <div className="ag-theme-quartz h-[70vh]" style={{ width: "100%" }}>
      <AgGridReact
        rowData={rowData}
        columnDefs={columnDefs}
        onRowClicked={(event) => {
          handleRowClick(event.data);
        }}
        defaultColDef={{
          wrapText: false,
          autoHeight: true,
          cellStyle: { whiteSpace: "normal" },
        }}
      />
    </div>
  );
};

export default ManageVotersTableView;
